import axios from 'axios';
import { GET_ERRORS} from '../actions/types'


export const uploadEpub = restaurantData => dispatch => {
    return axios
      .post('/api/upload/book', restaurantData, {
        headers: { 'Content-Type': 'multipart/form-data', }
      })
      .then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
  
        if (err.response.data != null && err.response.data.validation) {
          console.log(err.response.data);
          err = err.response.data
        } else {
          err = { "msg": "Something went wrong" }
        }
  
        return Promise.reject(err)
      });
  
  };

  export const uploadImage = restaurantData => dispatch => {
    return axios
      .post('/api/image', restaurantData, {
        headers: { 'Content-Type': 'multipart/form-data', }
      })
      .then(res => {
        console.log(res)
        return Promise.resolve(res.data)
      })
      .catch(err => {
  
        if (err.response.data != null && err.response.data.validation) {
          console.log(err.response.data);
          err = err.response.data
        } else {
          err = { "msg": "Something went wrong" }
        }
  
        return Promise.reject(err)
      });
  
  };

  export const getBookParentCategory = () => dispatch => {
    return axios
        .get('api/parentcategory')
        .then((res) => {
            console.log(res)
            return Promise.resolve(res.data)
        }).catch((err) => {
            console.log(err)
            return Promise.reject(err)
        })
  }

  export const getBookCategory = () => dispatch => {
    return axios
        .get('api/publicationcategory')
        .then((res) => {
            console.log(res)
            return Promise.resolve(res.data)
        }).catch((err) => {
            console.log(err)
            return Promise.reject(err)
        })
  }

  export const createBook = bookData => dispatch => {
    return axios
      .post('api/book', bookData)
      .then(res => {
        return Promise.resolve(res.data)
      })
      .catch(err => {
  
        if (err.response.data != null && err.response.data.validation) {
          console.log(err.response.data.validation);
          err = err.response.data
        } else {
          err = { "msg": "Something went wrong" }
        }
        dispatch({
          type: GET_ERRORS,
          payload: err
        })
        return Promise.reject(err)
      });
  };

  export const getAllBooks = () => dispatch => {
    return axios
        .get('/api/publisher/book')
        .then((res) => {
            console.log(res)

            return Promise.resolve(res.data)
        }).catch((err) => {
            console.log(err)
            return Promise.reject(err)
        })


}

export const uploadBook = restaurantData => dispatch => {
  return axios
    .post('/api/bookconvert/upload', restaurantData, {
      headers: { 'Content-Type': 'multipart/form-data', }
    })
    .then(res => {
      return Promise.resolve(res.data)
    })
    .catch(err => {

      if (err.response.data != null && err.response.data.validation) {
        console.log(err.response.data);
        err = err.response.data
      } else {
        err = { "msg": "Something went wrong" }
      }

      return Promise.reject(err)
    });

};
export const getConversionPrice = () => dispatch => {
  return axios
      .get('api/conversionprice')
      .then((res) => {
          console.log(res)
          return Promise.resolve(res.data)
      }).catch((err) => {
          console.log(err)
          return Promise.reject(err)
      })
}
export const createBookConverReq = bookData => dispatch => {
  return axios
    .post('api/bookconvert', bookData)
    .then(res => {
      return Promise.resolve(res.data)
    })
    .catch(err => {

      if (err.response.data != null && err.response.data.validation) {
        console.log(err.response.data);
        err = err.response.data
      } else {
        err = { "msg": "Something went wrong" }
      }
      dispatch({
        type: GET_ERRORS,
        payload: err
      })
      return Promise.reject(err)
    });
};
export const updateBookConverReq = bookData => dispatch => {
  return axios
    .put('api/bookconvert', bookData)
    .then(res => {
      return Promise.resolve(res.data)
    })
    .catch(err => {

      if (err.response.data != null && err.response.data.validation) {
        console.log(err.response.data);
        err = err.response.data
      } else {
        err = { "msg": "Something went wrong" }
      }
      dispatch({
        type: GET_ERRORS,
        payload: err
      })
      return Promise.reject(err)
    });
};
export const getConversionBooks = () => dispatch => {
  return axios
      .get('/api/bookconvert')
      .then((res) => {
          console.log(res)

          return Promise.resolve(res.data)
      }).catch((err) => {
          console.log(err)
          return Promise.reject(err)
      })


}

export const downloadFile = (Book_Name) => dispatch => {
  return axios
      .get('/api/download?Book_Name='+Book_Name)
      .then((res) => {
          //console.log(res)

          return Promise.resolve(res.data)
      }).catch((err) => {
          //console.log(err)
          return Promise.reject(err)
      })


}

export const sortAllBooks = (Name,Sort) => dispatch => {
  return axios
      .get('/api/publisher/sort/book?Name='+Name+'&Sort='+Sort)
      .then((res) => {
          console.log(res)

          return Promise.resolve(res.data)
      }).catch((err) => {
          console.log(err)
          return Promise.reject(err)
      })


}
export const searchBook = (Name) => dispatch => {
  return axios
      .get('/api/publisher/search/book?Name='+Name)
      .then((res) => {
          console.log(res)

          return Promise.resolve(res.data)
      }).catch((err) => {
          console.log(err)
          return Promise.reject(err)
      })


}

export const getEasyPayMbl = accountData => dispatch => {
  return axios
    .post('https://easypay.easypaisa.com.pk/easypay-service/rest/v4/initiate-ma-transaction', accountData, {headers: {'Credentials':'TGl0dGxlQm9va0NvbXBhbnk6YjllYmY2NDFiMmRmYTY3YTFiOWNkNDFkMjFjMGI5NzQ='}})
    .then(res => {
      console.log(res)
      return Promise.resolve(res.data)
    })

    .catch(err => {

      // if (err.response.data != null && err.response.data.validation) {
      //   console.log(err.response.data);
      //   err = err.response.data
      // } else {
      //   err = { "msg": "Something went wrong" }
      // }
      // dispatch({
      //   type: GET_ERRORS,
      //   payload: err
      // })
      console.log(err)
      return Promise.reject(err)
    });
};
